import React from 'react';
import moment from 'moment';
import i18next from 'i18next';

function CustomTooltip(props) {
  const { payload, active, graphType, dataTypeToken } = props;
  if (active && payload && payload[0] && payload[0].payload) {
    if (dataTypeToken) {
      return (
        <div className="custom-tooltip">
          <p><span>{i18next.t('graphing.reported-at')}:</span> {moment.unix(payload[0].payload.timestamp).utc().format("L LT")}</p>
          <p><span>{i18next.t('graphing.state')}:</span> {payload[0].value === 2 ? i18next.t(`device-data-types.state-values.${dataTypeToken}.true`) : i18next.t(`device-data-types.state-values.${dataTypeToken}.false`)}</p>
        </div>
      );  
    } else if (graphType === "door") {
      return (
        <div className="custom-tooltip">
          <p><span>{i18next.t('graphing.reported-at')}:</span> {moment.unix(payload[0].payload.timestamp).utc().format("L LT")}</p>
          <p><span>{i18next.t('graphing.state')}:</span> {payload[0].value === 2 ? i18next.t('magnetometer-data-string-display.Open') : i18next.t('magnetometer-data-string-display.Closed')}</p>
        </div>
      );
    } else if (graphType === "connectivity-status") {
      return (
        <div className="custom-tooltip">
          <p><span>{i18next.t('graphing.reported-at')}:</span> {moment.unix(payload[0].payload.timestamp).utc().format("L LT")}</p>
          <p><span>{i18next.t('graphing.state')}:</span> {payload[0].value === 2 ? i18next.t('connectivity-status-data-string-display.Online') : i18next.t('connectivity-status-data-string-display.Offline')}</p>
        </div>
      );
    } else {
      return (
        <div className="custom-tooltip">
          <p><span>{i18next.t('graphing.reported-at')}:</span> {moment.unix(payload[0].payload.timestamp).utc().format("L LT")}</p>
          <p><span>{i18next.t('graphing.value')}:</span> {payload[0].value}</p>
        </div>
      );
    }
  }
  return null;
}

export default CustomTooltip;
